import { useBlocker } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

export function usePrompt(
  when: boolean = true,
  message: string = 'common:areYouSureYouWantToLeaveThePage',
) {
  const { t } = useTranslation();

  return useBlocker({
    shouldBlockFn: () => {
      if (!when) {
        return false;
      }

      const result = confirm(t(message));

      return !result;
    },
    enableBeforeUnload: when,
  });
}
